import type { TablePaginationConfig } from "antd";
import type { AppTablePagination } from "../types/on-change";

export const getAppTablePagination = (pagination: TablePaginationConfig): AppTablePagination => {
  return {
    current: pagination.current,
    pageSize: pagination.pageSize,
    total: pagination.total,
  };
};
